import { PaginationRequest } from '@repo/ui/data-table'

import { CurrencyEnum } from '../../lib/types/enums/common/currency.enum'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CenterOlPaymentsTotalAmountsByCurrency = {
  currency: CurrencyEnum
  totalAmount: number
}

export function getCenterOlPaymentTotalAmountsByCurrency(input?: PaginationRequest) {
  return restApiClient
    .url(encodeNestedObject(API.centerOlPayments.getTotalAmountsByCurrency.url, input))
    .get<CenterOlPaymentsTotalAmountsByCurrency[]>()
}
